import { computed, ref, watch } from 'vue';
import { defineStore } from 'pinia';
import { useAuthStore } from './auth';

/** Личный эксперимент Яны. Имя и роль не подходят: они есть и у других сотрудников. */
export const useMascotStore = defineStore('mascot', () => {
  const auth = useAuthStore();
  const hidden = ref(false);
  const introduced = ref(false);
  const home = ref<'edge' | 'header'>('edge');
  const carrying = ref(false);
  const available = computed(() => Boolean(
    auth.user?.isActive && !auth.user.mustChangePassword && auth.user.username === 'yana',
  ));
  const visible = computed(() => available.value && !hidden.value);
  const storageKey = () => `yana.mascot.${auth.user?.id}.hidden`;

  watch(() => auth.user?.id, () => {
    introduced.value = false;
    home.value = 'edge';
    carrying.value = false;
    try { hidden.value = localStorage.getItem(storageKey()) === 'true'; }
    catch { hidden.value = false; }
  }, { immediate: true, flush: 'sync' });

  function setHidden(value: boolean): void {
    if (!available.value) return;
    hidden.value = value;
    if (!value) introduced.value = false;
    try { localStorage.setItem(storageKey(), String(value)); }
    catch { /* Настройка продолжает действовать в этой вкладке. */ }
  }

  return { available, visible, introduced, home, carrying, setHidden };
});
